/**
 * メッセージ出力モジュール
 */
import { VueConstructor } from 'vue/types/umd'
import { ConfirmParams, Message } from '@/store/types'

export interface IMessageOutputFunc {
  (message: Message): void
}
export interface IConfirmOutputFunc {
  (confirm: ConfirmParams): Promise<boolean>
}

export const MessageOutput = function(vue: VueConstructor<Vue>): IMessageOutputFunc {
  return (message: Message) => {
    vue.prototype.$notify({
      title: message.title,
      message: message.message,
      dangerouslyUseHTMLString: true,
      type: message.type,
      offset: message.offset  
    })
  }
}
export const ConfirmOutput = (vue: VueConstructor<Vue>): IConfirmOutputFunc => {
  return async (params: ConfirmParams) => {
    const message = `${params.title ? `<h1><b>${params.title}</b></h1>` : ''}<p>${
      params.message
    }</p>`
    return new Promise(resolve => {
      vue.prototype.$buefy.dialog.alert({
        message,
        dangerouslyUseHTMLString: true,
        type: params.type,
        hasIcon: true,
        canCancel: params.canCancel,
        confirmText: params.confirmText,
        cancelText: params.cancelText,
        onConfirm: () => resolve(true),
        onCancel: () => resolve(false)
      })
    })
  }
}
